// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".livestream-tabs__tab-img[data-v-7b65061e]{margin-left:-4px;margin-right:5px}.livestream-tabs__tab-img--inactive[data-v-7b65061e]{filter:invert(100%)}.tab-component[data-v-7b65061e].stream-slot-list{padding-left:16px}.tab-component[data-v-7b65061e].stream-slot-list .swiper-container{margin-left:-16px;padding-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
